export function userInitials(username: string | null): string {
  if (!username?.trim()) return '?';
  const local = username.split('@')[0]?.trim() || username.trim();
  const parts = local.split(/[.\s_-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0]![0] ?? ''}${parts[1]![0] ?? ''}`.toUpperCase();
  }
  return local.slice(0, 2).toUpperCase();
}

export function userDisplayName(username: string | null, displayName?: string | null): string {
  if (displayName?.trim()) return displayName.trim();
  if (!username?.trim()) return 'User';
  const local = username.split('@')[0]?.trim();
  return local || username;
}
